export const GET_STORES_MAX_DISTANCE_KM = 20;
